import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { Form } from "@/ui/Form";
import { useLink } from "@/hooks/useLink";

export const JobPageApplySection = ({ className, id }) => {
  const locale = useLocale();
  const link = useLink();

  const onSubmitDone = () => {
    if (typeof window !== "undefined") {
      window.location.href = link("jobs.form.complete");
    }
  };

  return (
    <div className={clsx(className)}>
      <a id="apply" />
      <div className={clsx(classes.form, "p-4 p-md-5 mb-5")}>
        <DynamicText path={`page.job.form.title.${locale}`} tag="h3" />
        <Form jobId={id} onSubmitDone={onSubmitDone} />
      </div>
    </div>
  );
};
